import React from "react";
import { Badge, Card, CardBody, CardHeader } from "reactstrap";
import moment from "moment";

interface MessageTimeLineItemProps {
  userName?: string;
  value: string;
  creationTime?: Date;
  action?: number;
  isAdditionalRequest?: boolean;
  isDailyApproval?: boolean;
  dailyDate?: string | null;
}

const getActionLabel = (action?: number) => {
  switch (action) {
    case 1:
      return "approved";
    case 2:
      return "rejected";
    case 3:
      return "sent for review";
    case 4:
      return "saved";
    default:
      return "did an action";
  }
};

const MessageTimeLineItem = ({
  userName,
  value,
  creationTime,
  action,
  isAdditionalRequest,
  isDailyApproval,
  dailyDate,
}: MessageTimeLineItemProps) => {
  return (
    <div className="d-flex mb-3" key={creationTime?.toString()}>
      <Card className="w-100">
        <CardHeader>
          {userName ? (
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
                <strong>{userName}</strong>
                {isDailyApproval !== undefined && (
                  <Badge color={isDailyApproval ? "info" : "primary"} pill>
                    {isDailyApproval ? "Daily" : "Weekly"}
                  </Badge>
                )}
                {isAdditionalRequest && (
                  <Badge color="warning" pill>
                    Additional requests
                  </Badge>
                )}
              </div>

              <span className="text-muted" style={{ fontSize: "0.85rem" }}>
                {getActionLabel(action)} on{" "}
                {moment(creationTime).format("DD-MM-YYYY HH:mm")}
              </span>
            </div>
          ) : (
            <strong>Comment</strong>
          )}
        </CardHeader>
        {(dailyDate || value) && (
          <CardBody>
            {dailyDate && (
              <div className={value ? "mb-2" : ""}>
                <span className="text-muted">Date: </span>
                <strong>{moment(dailyDate).format("DD-MM-YYYY")}</strong>
              </div>
            )}
            {value && (
              <div>
                <span className="text-muted">Comment: </span>
                {value}
              </div>
            )}
          </CardBody>
        )}
      </Card>
    </div>
  );
};

export default MessageTimeLineItem;
